// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { EventsCollectionModel, getEvents, GetEventsApiParameter } from "@werner/App/Services/EventService";


interface Props {
    apiParameter: GetEventsApiParameter;
    apiResult: EventsCollectionModel;
}

type Parameter = GetEventsApiParameter;

type HandlerType = Handler<Parameter, Props>;

export const BeginLoadingRequest: HandlerType = props => {
    props.dispatch({
        type: "TrainingCalender/SetIsLoading",
        parameter: props.parameter,
        isLoading: true,
    } as any);
};

export const DispatchBeginAction: HandlerType = props => {
  
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getEvents(props.apiParameter);
};

export const DispatchCompleteLoadTrainingCalenderEvents: HandlerType = props => {   
    if (props.apiResult) {
        props.dispatch({
            type: "TrainingCalender/SetEvents",
            data: props.apiResult,
            parameter: props.parameter,
        } as any);
    }
};

export const chain = [BeginLoadingRequest, DispatchBeginAction, RequestDataFromApi, DispatchCompleteLoadTrainingCalenderEvents];

const loadEvents = createHandlerChainRunner(chain, "LoadEventsHandler");
export default loadEvents;


